module.exports = __webpack_public_path__ + "media/images/banner/saibashi/banner_final-78c101d666a487ae260d6fa81778f4f8.jpg";